import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SettingsRoutingModule } from './settings-routing.module';
import { ImageUploadModule } from 'angular2-image-upload';
import { InvitesComponent } from './invites/create-invite/invites.component';
import { SnotifyModule } from 'ng-snotify';
import { BlogComponent } from './blogs/blog/blog.component';
import { FaqsComponent } from './faqs/create-faq/faqs.component';
import { QuillModule } from 'ngx-quill';
import { SharedModule } from '../shared/shared.module';
import { HighlightModule, HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { InvitesListComponent } from './invites/invites-list/invites-list.component';
import { BlogListComponent } from './blogs/blog-list/blog-list.component';
import { StaticPageContentComponent } from './static-page-content/static-page-content.component';
import { GeneralSettingComponent } from './general-setting/general-setting.component';
import { DatePipe } from '@angular/common';
import { FaqsListComponent } from './faqs/faqs-list/faqs-list.component';
import { FaqsGroupComponent } from './faqs/faqs-group/faqs-group.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { AboutComponent } from './about/create-about/about.component';
import { ContactComponent } from './contact/create-contact/contact.component';
import { AddItemsComponent } from './blogs/add-article-item/add-article-item.component';

/**
 * Import specific languages to avoid importing everything
 * The following will lazy load highlight.js core script (~9.6KB) + the selected languages bundle (each lang. ~1kb)
 */
export function getHighlightLanguages() {
  return {
    typescript: () => import('highlight.js/lib/languages/typescript'),
    css: () => import('highlight.js/lib/languages/css'),
    xml: () => import('highlight.js/lib/languages/xml')
  };
}
@NgModule({
  declarations: [
    InvitesComponent,
    BlogComponent,
    FaqsComponent,
    InvitesListComponent,
    BlogListComponent,
    StaticPageContentComponent,
    GeneralSettingComponent,
    FaqsListComponent,
    FaqsGroupComponent,
    AboutComponent,
    ContactComponent,
    AddItemsComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SettingsRoutingModule,
    SharedModule,
    FormsModule,
    SnotifyModule,
    HighlightModule,
    ImageUploadModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    QuillModule.forRoot({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline'],
          [{ list: 'bullet' }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ font: [] }],
          [{ align: [] }]
        ]
      }
    }),
    SharedModule
  ],
  exports: [],
  providers: [
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        languages: getHighlightLanguages()
      }
    },
    DatePipe,
  ]
})
export class SettingsModule { }
